module.exports = __webpack_public_path__ + "img/location-disabled-purple.4891b5f0.svg";